import { render } from "./OnTheWayListForSale.vue?vue&type=template&id=d87a329a&scoped=true"
import script from "./OnTheWayListForSale.vue?vue&type=script&lang=js"
export * from "./OnTheWayListForSale.vue?vue&type=script&lang=js"

import "./OnTheWayListForSale.vue?vue&type=style&index=0&id=d87a329a&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d87a329a"]])

export default __exports__